import React from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  LinearProgress,
  Badge,
} from "@mui/material";

const ProviderList = ({
  providers,
  loading,
  selectedProvider,
  onSelect,
  theme,
  messageCounts,
}) => (
  <Box sx={{ width: 320, bgcolor: "#ffffff" }}>
    <Box sx={{ p: 2, bgcolor: theme.palette.primary.main }}>
      <Typography sx={{ color: "#fff", fontWeight: 600 }}>Providers</Typography>
    </Box>

    <List disablePadding>
      {loading ? (
        <LinearProgress />
      ) : (
        providers.map((p) => (
          <div key={p.mobile_username}>
            <ListItemButton
              selected={selectedProvider?.mobile_username === p.mobile_username}
              onClick={() => onSelect(p)}
            >
              <ListItemAvatar>
                <Badge
                  badgeContent={messageCounts?.[p.mobile_username] || 0}
                  color="error"
                  invisible={!messageCounts?.[p.mobile_username]}
                >
                  <Avatar>{p.fullname?.[0]}</Avatar>
                </Badge>
              </ListItemAvatar>
              <ListItemText
                primary={p.fullname}
                secondary={p.specialty || "Provider"}
              />
            </ListItemButton>
            <Divider />
          </div>
        ))
      )}
    </List>
  </Box>
);

export default ProviderList;
